<template>
<div class="chapter">
<div class="inner_page">
<p class="imagea"><a id="page_vii"></a><img alt="image" src="images/f00vii-01.jpg"/></p>
<p class="caption">Bert Bell, NFL commissioner 1946–1959. (Courtesy of <em>The Sporting News</em>/Zuma Press)</p>
<p class="image"><img alt="image" src="images/f00vii-02.jpg"/></p>
<p class="caption">Giants third-quarter goal-line stand. (Courtesy of Hy Peskin/<em>Sports Illustrated</em>)</p>
<p class="imagea"><a id="page_viii"></a><img alt="image" src="images/f0viii-01.jpg"/></p>
<p class="caption">New York assistant coach Tom Landry (with ball) and the Giants’ defense, Nov. 6, 1958. (Courtesy of AP)</p>
<p class="image"><img alt="image" src="images/f0viii-02.jpg"/></p>
<p class="caption">Baltimore head coach, Weeb Ewbank, briefs his team on the day before the big game, Dec. 27, 1958. (Courtesy of AP)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// photos.vue?2dd63dae